import React from 'react';
// @ts-ignore
import * as styles from './anchorLink.module.css';

interface AnchorLinkProps {
    targetId: string | undefined;
    color?: string;
    hoverBorderColor?: string;
    hoverFontColor?: string;
    hoverBgColor?: string;
    visualStyle?: 'outlineDark' | 'outlineLight';
    id?: string;
    elementCodename?: string;
    children: string;
}

const AnchorLink: React.FC<AnchorLinkProps> = ({
    targetId,
    color,
    hoverBorderColor,
    hoverFontColor,
    hoverBgColor,
    visualStyle = 'outlineDark',
    id,
    elementCodename = 'cta_configuration__cta_label',
    children,
}) => {
    const inlineStyle: React.CSSProperties = {};
    const hoverBorderColorHex = hoverBorderColor || '#f06623';
    const hoverFontColorHex = hoverFontColor || '#ffffff';
    const hoverBgColorHex = hoverBgColor || '#f06623';

    if (color) {
        inlineStyle.color = color;
        inlineStyle.borderColor = color;
    }

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();

        if (!targetId) return; // Ensure targetId is defined

        const newHash = `#${targetId}`;
        const currentHash = window.location.hash;

        // Update the URL hash if it's different
        if (currentHash !== newHash) {
            history.replaceState(
                null,
                '',
                `${window.location.pathname}${window.location.search}${newHash}`
            );
        }

        // Scroll to the target element
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
            const offset = 150; // Adjust this value to move further up or down
            const top =
                targetElement.getBoundingClientRect().top +
                window.scrollY -
                offset;
            window.scrollTo({ top, behavior: 'smooth' });
        }
    };

    return (
        <>
            {color && (
                <style>{`.${styles.ctaLink}:hover { 
          border-color: ${hoverBorderColorHex} !important; 
          color: ${hoverFontColorHex} !important;
          background-color: ${hoverBgColorHex} !important;
        }`}</style>
            )}
            <a
                id={id}
                href={`${
                    typeof window !== 'undefined'
                        ? `${window.location.pathname}${window.location.search}`
                        : ''
                }#${targetId}`}
                onClick={handleClick}
                className={`${styles.ctaLink} ${styles[visualStyle]}`}
                style={inlineStyle}
                {...(elementCodename
                    ? { 'data-kontent-element-codename': elementCodename }
                    : {})}
            >
                {children}
            </a>
        </>
    );
};

export default AnchorLink;
